import { render, staticRenderFns } from "./part4.vue?vue&type=template&id=add1aa48&"
import script from "./part4.vue?vue&type=script&lang=js&"
export * from "./part4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports